/* template */
<template><div class="mpx-root-view"><div :style='["padding-left: 40px; height: 60px;margin-top:20px;"] | transRpxStyle'><mpx-input :style='["height: 60px;"] | transRpxStyle' type="file" @change="upload" accept="image/jpg,image/jpeg,image/png"/></div><div><mpx-image :src="(imgSrc)"></mpx-image></div></div></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mad2a7254"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./upload.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./upload.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mad2a7254"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
